const NormaliseExt = (value:any) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if(value.length >3){
      return onlyNums.slice(0, 3)
  }
  else return onlyNums
}

export default NormaliseExt